webpackJsonp([82121297150369],{

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SuhelaKhan = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _insights_constants = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(22);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _jquery = __webpack_require__(26);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sendMailIcon = __webpack_require__(30);
	
	var _sendMailIcon2 = _interopRequireDefault(_sendMailIcon);
	
	var _MailForwardForm = __webpack_require__(27);
	
	var _MailForwardForm2 = _interopRequireDefault(_MailForwardForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/KhyatiParekh.jpeg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SuhelaKhan = exports.SuhelaKhan = function (_React$Component) {
	  _inherits(SuhelaKhan, _React$Component);
	
	  function SuhelaKhan(args) {
	    _classCallCheck(this, SuhelaKhan);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleMailShareForm = function () {
	      _this.setState({ showMailShareForm: !_this.state.showMailShareForm });
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.handleMenu = function (item) {
	      _this.setState({
	        activeTitle: item.title
	      });
	
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      if (item.title === "SORT BY") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else if (item.title === "ALL") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else {
	        [].concat(leftlist).filter(function (insight) {
	          console.log(insight);
	          // a.typee.indexOf(item.title) >= 0}
	          var flag = false;
	          for (var i = 0; i < insight.itype.length; i++) {
	            if (item.title === insight.itype[i]) {
	              flag = true;
	            }
	          }
	          return flag;
	        }).forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      }
	      _this.setState({
	        activeSortBy: item.title
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      var str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      leftlist.forEach(function (item) {
	        if (item.skey.toLowerCase().trim().search(str) > -1) {
	          _this.betterContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      activeKeyword: "",
	      isSearching: false,
	      lastCounter: 3,
	      activeTitle: "SORT BY",
	      activeSortBy: "default",
	      showMailShareForm: false
	    };
	    _this.betterContent = _insights_constants.insightsConstants;
	
	    _this.Speaker = [{
	      desc: "<div> \n        </div>",
	      name: "Khyati Parekh",
	      post: "General Counsel, Edelweiss Alternatives",
	      imgUrl: icon1,
	      head: "Does it ‘look difficult’ or should I just say ‘no’?"
	    }];
	    return _this;
	  }
	
	  SuhelaKhan.prototype.componentDidMount = function componentDidMount() {
	    // function sticky_relocate () {
	    // 	var window_top = $(window).scrollTop()
	    // 	var div_top = $("#sticky-anchor").offset().top
	    // 	if (window_top > div_top) {
	    // 		$("#sticky").addClass("stick")
	    // 	} else {
	    // 		$("#sticky").removeClass("stick")
	    // 	}
	    // }
	    // $(function () {
	    // 	$(window).scroll(sticky_relocate)
	    // 	sticky_relocate()
	    // })
	  };
	
	  SuhelaKhan.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isSearching = _state.isSearching,
	        isShow = _state.isShow,
	        activeTitle = _state.activeTitle,
	        activeSortBy = _state.activeSortBy;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Does it \u2018look difficult\u2019 or should I just say \u2018no\u2019? ",
	          image: "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg",
	          description: "As I put one foot in front of the other, trading in the instructor\u2019s jump-squat-bend-twist- circus for my own \u2018Itni muddat baad mile ho\u2019 on Spotify on my noise cancelling earphones, I drowned out the cacophony and found a moment of peace in this country that is never quiet!",
	          location: location
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "insights_wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "insights_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "insights_content" },
	                _react2.default.createElement("div", { className: "drop_src_box" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-md-12" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 2,
	                          animateIn: "slideInRight",
	                          offset: 600
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_right_text" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_blog_page" },
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text" },
	                              this.Speaker.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "row" },
	                                  _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                      delay: 0,
	                                      duration: 1,
	                                      animateIn: "zoomIn",
	                                      offset: 100
	                                    },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-3 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "right_img_section"
	
	                                        },
	                                        _react2.default.createElement("img", {
	                                          src: item.imgUrl, style: { width: '100%' },
	                                          alt: "Suhela khan",
	                                          className: "img-responsive"
	                                        })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-9 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_name_section" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_head" },
	                                          item.head
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_name" },
	                                          item.name
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_post" },
	                                          "General Counsel, Edelweiss\xA0Alternatives "
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_block" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "POEM"
	                                          ),
	                                          " \u2022 6 mins read"
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "share_section_one" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "headsocialLink" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://www.linkedin.com/in/khyati-parekh-0808a87/?originalSubdomain=in",
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text_btm" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text_section" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "into_text", style: { fontStyle: 'normal' } },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: " ", style: { textAlign: 'left' } },
	                                    "I decided to walk. My best walks have been ones when I skedaddle from the workout studio and decide to enjoy the breeze. Where I take a walk, and tell the studio to take one too!",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "As I put one foot in front of the other, trading in the instructor\u2019s jump-squat-bend-twist- circus for my own ",
	                                    _react2.default.createElement(
	                                      "i",
	                                      null,
	                                      "\u2018Itni muddat baad mile ho\u2019"
	                                    ),
	                                    " on Spotify on my noise cancelling earphones, I drowned out the cacophony and found a moment of peace in this country that is never quiet!",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Ohh, the sweet permission to skip an early class on a Tuesday morning.",
	                                    _react2.default.createElement("br", null),
	                                    "Or a long review on a Thursday evening. ",
	                                    _react2.default.createElement("br", null),
	                                    "Or a boring social do on a Sunday. ",
	                                    _react2.default.createElement("br", null),
	                                    "An outing you were dreading for 15 days in a row now. ",
	                                    _react2.default.createElement("br", null),
	                                    "Counting down as your heart sank a centimetre every day. ",
	                                    _react2.default.createElement("br", null),
	                                    "Fantasizing, imagining and hoping for all kinds of dreadful things to happen, just so you can SKIP!",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "How much weight actually lifts, as one skips!",
	                                    _react2.default.createElement("br", null),
	                                    "Skip is such an onomatopoeic word, come to think! \uD83D\uDE0A",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "And the grand permission - to do.",
	                                    _react2.default.createElement("br", null),
	                                    "To go.",
	                                    _react2.default.createElement("br", null),
	                                    "To come.",
	                                    _react2.default.createElement("br", null),
	                                    "To get it done. ",
	                                    _react2.default.createElement("br", null),
	                                    "To close a deal.",
	                                    _react2.default.createElement("br", null),
	                                    "To call the shots. ",
	                                    _react2.default.createElement("br", null),
	                                    "To own a piece of work.",
	                                    _react2.default.createElement("br", null),
	                                    "And may I say, to even run your kitchen.",
	                                    _react2.default.createElement("br", null),
	                                    "To come up with unorthodox solutions like hiring six part timers instead of one full timer who will hold you ransom (because you dread the hassle & the housework that would bring!).",
	                                    _react2.default.createElement("br", null),
	                                    "Ohh, the permission to run one\u2019s life!",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "And the ludicrousness of waiting for imaginary permissions.",
	                                    _react2.default.createElement("br", null),
	                                    "Like the one to \u2018just be\u2019, instead of \u2018to do\u2019.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "As I walked, I also saw again, a light I\u2019ve seen many times before.",
	                                    _react2.default.createElement("br", null),
	                                    "That this ridiculous spandex I\u2019m wearing, I\u2019m allowed to take off.",
	                                    _react2.default.createElement("br", null),
	                                    "This circus crowd claps a bit more for the mermaid that sings, but that is also her curse.",
	                                    _react2.default.createElement("br", null),
	                                    "While the clowns drop their colourful pants and goof around, only some of them are not putting on an act.",
	                                    _react2.default.createElement("br", null),
	                                    "The kids think the calisthenics athletes are magicians. ",
	                                    _react2.default.createElement("br", null),
	                                    "The circus will come and go, I can watch or join at will or at ease.",
	                                    _react2.default.createElement("br", null),
	                                    "There isn\u2019t a last or only show. ",
	                                    _react2.default.createElement("br", null),
	                                    "I can choose to also change auditoriums or genres. ",
	                                    _react2.default.createElement("br", null),
	                                    "As I have, for lifetimes now.",
	                                    _react2.default.createElement("br", null),
	                                    "And each time, I see it, I forget as quickly.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Oh, great Magician in the Sky, how sweet are your games?",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement(
	                                      "i",
	                                      null,
	                                      "Baharon ko chaman, yaad aa gaya hai\u2026"
	                                    ),
	                                    ". Spotify knows my obsession with Ghulam Ali.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Permission to know and to remember,",
	                                    _react2.default.createElement("br", null),
	                                    "The gentle breath of the earth, the trees in Kabini, the glorious rainforests, of the sun in Bali and the ocean in Kotakinabalu and the deeply magical valleys of Cappadocia.",
	                                    _react2.default.createElement("br", null),
	                                    "Of travel, which is to hack to see better and more clearly with the heart.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "The phone rings.  \u201CMa, how long before you\u2019re home? We\u2019re waiting for breakfast!\u201D",
	                                    _react2.default.createElement("br", null),
	                                    "\u201CAnother hour, beta. You guys manage.\u201D Not go-ahead, manage.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Today I am giving myself the space to breathe and someday, I will also try \u201Cthat word that cannot be said\u201D, whose cousin I use so often when I say, \u2018it looks difficult\u2019.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement(
	                                      "i",
	                                      null,
	                                      "Dil mein ek leher sii uthi hai abhi\u2026"
	                                    ),
	                                    ".",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "How exhilrating might it be to just say \u2013 \u201Cno\u201D, without launching into long explanations and mummifying it in layers of polite-ism. Someday I will also give myself the permission to exit some family whatsapp groups.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Realizing that these are green slips (why is \u2018green slip\u2019 not a dictionary term yet?), I myself can and need to give myself.",
	                                    _react2.default.createElement("br", null),
	                                    "To go first, while the world is hell bent on making me play second.",
	                                    _react2.default.createElement("br", null),
	                                    "And to question my own deep training that thinks it is fine.",
	                                    _react2.default.createElement("br", null),
	                                    "To call out the biases conscious & \u2018un\u2019.",
	                                    _react2.default.createElement("br", null),
	                                    "To start occupying space, instead of feeling like I\u2019m just holding it, or worse, intruding.",
	                                    _react2.default.createElement("br", null),
	                                    "To own my voice, in the unique perspective it brings to the world and the workplace.",
	                                    _react2.default.createElement("br", null),
	                                    "To be ok to \u2018not have it together\u2019. ",
	                                    _react2.default.createElement("br", null),
	                                    "To allow imperfection ",
	                                    _react2.default.createElement("br", null),
	                                    "And holding my heart, for however long it needs to be held. ",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Like the quality of mercy, permission is also twice blessed!",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement(
	                                      "i",
	                                      null,
	                                      "Chupke chupke, raat din\u2026 aasoon bahana yaad hai\u2026"
	                                    ),
	                                    ".",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "[This essay was written in the Ochre Sky Memoir Writing Workshop organized by Natasha Badhwar and Raju Tai]"
	                                  )
	                                ),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement("div", { className: "r_text_Q" })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(TeamModal, {
	              show: isShow,
	              onHide: this.togglePopUp,
	              activeItem: this.state.activeItem
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return SuhelaKhan;
	}(_react2.default.Component);
	
	SuhelaKhan.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SuhelaKhan;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-does-it-look-difficult-or-should-i-just-say-no-index-js-235b56d75808dd71021e.js